import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: auto;
`
export const Content = styled.div`
  width: calc(80vw - 350px);
  left: 250px;
  height: 100vh;
  overflow-y: visible;
`
export const CompanyCard = styled.div`
  background: #ffffff;
  border: none;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 47px 70px 70px 47px;
`
export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
`
export const InformationCompany = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-self: center;
  width: 50%;
  align-items: center;
  gap: 50px;
`

interface ILabelDiv {
  alignItems?: string
  justifyContent?: string
  width?: string
  height?: string
}

export const FormContainerItem = styled.div<ILabelDiv>`
  align-self: center;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  text-align: start;
`
export const IconSvgProfile = styled.svg`
  color: #2d749c;
  fill: #2d749c;
  width: 24px;
  height: 24px;
`

export const LabelDiv = styled.div<ILabelDiv>`
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: ${(props) => props.alignItems || 'center'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
`

export const Label = styled.label`
  font-size: 14px;
  color: #1f2124;
  font-weight: 600;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
`

export const BluesiteTable = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: collapse;
`
export const TableDivider = styled.hr`
  border: 1px solid #1f2124;
  width: 100%;
`
export const TableHeaders = styled.thead`
  margin-bottom: 30px;
  border-bottom: 1px solid #1f2124;
  padding: 0.3em;
  justify-content: space-between;
`
export const ActionsCell = styled.th`
  justify-content: flex-end;
  width: 25%;
`
export const TableBody = styled.tbody`
  border-top: 1px solid;
  padding-top: 30px;
  justify-content: space-between;
  .link-editar {
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 22px;
    color: #2d749c;
  }
`

export const EditLinkWrapper = styled.div`
  display: flex;
  float: right;
  color: #2d749c;
  font-size: 15px;
  font-weight: bold;
  align-items: center;
  gap: 5px;
`

export const TableSelect = styled.select`
  width: 63px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: none;
  margin: 10px;
  padding: 10px;
`
export const OptionSelect = styled.option`
  padding: 10px;
`
export const UpdateLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e44646;
  font-weight: bold;
  cursor: pointer;
`

export const ActionIcon = styled.svg`
  fill: #e44646;
  clip-rule: evenodd;
  fill-rule: evenodd;
  stroke-linejoin: round;
  stroke-miterlimit: 2;
  width: 24px;
  height: 24px;
  margin-right: 5px;
`

interface IRow {
  height?: string
  width?: string
  justifyContent?: string
  alignItems?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'center'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || 'auto'};
`
export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 40px;
  margin-top: 40px;
`
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  width: 85%;
  height: 92px;
  padding: 12px;
`

export const CardDescriptionSection = styled.div`
  margin: 10px;
`
export const PointerLabel = styled.label`
  cursor: pointer;
`

// Nuevos componentes para la vista de inventario con historial

export const InventoryContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  margin-top: 20px;
  min-height: 70vh;
`

export const InventoryListContainer = styled.div`
  width: 50%;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;

  h6 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InventoryDetailContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const InventoryDetailHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  h6 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InventoryDetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`

export const InventoryInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f1f1f1;

  &:last-child {
    border-bottom: none;
  }

  strong {
    font-weight: 600;
  }
`

export const InventoryHistoryContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
`

export const InventoryHistoryHeader = styled.div`
  padding: 15px 20px;
  border-bottom: 1px solid #f1f1f1;

  h6 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }
`

export const InventoryHistoryContent = styled.div`
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  max-height: 300px;

  p {
    text-align: center;
    color: #888;
    margin-top: 20px;
  }
`

export const HistoryItem = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 8px;
  background-color: #f8f9fa;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
`

export const HistoryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eaeaea;

  span {
    color: #666;
    font-size: 14px;
  }

  strong {
    font-weight: 600;
    color: #2d749c;
  }
`

export const HistoryItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  span {
    font-size: 14px;
  }
`

export const NoInventorySelected = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 40px;

  p {
    color: #888;
    text-align: center;
    font-size: 16px;
  }
`

// Nuevos estilos para edición de inventario
export const EditInventoryForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`

export const EditFormRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f1f1;

  &:last-child {
    border-bottom: none;
  }
`

export const EditFormLabel = styled.label`
  font-weight: 600;
  min-width: 180px;
`

export const EditFormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`

// Indicador visual para fila seleccionada
export const SelectedRow = styled.div`
  position: absolute;
  left: 0;
  height: 100%;
  width: 6px;
  background-color: #c6016b;
  z-index: 1;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: 0 0 5px rgba(198, 1, 107, 0.5);
`

// Añadir un nuevo estilo para las filas seleccionadas
export const TableRowSelected = styled.tr`
  background-color: rgba(198, 1, 107, 0.08);
  position: relative;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(198, 1, 107, 0.12);
  }

  td {
    position: relative;
  }

  td:first-child {
    border-left: 4px solid #c6016b;
  }
`
